import { render } from "./LegoBeforeSteps.vue?vue&type=template&id=21f65db2"
import script from "./LegoBeforeSteps.vue?vue&type=script&lang=js"
export * from "./LegoBeforeSteps.vue?vue&type=script&lang=js"
script.render = render

export default script